function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M120.496 63.513l.038.038.165.024a9.765 9.765 0 018.35 8.865l.036.44.44.019a17.738 17.738 0 11-5.034 34.936l-.412-.103-.168.39a14.19 14.19 0 11-25.547-12.3l.203-.38-.345-.256-.547-.408a11.781 11.781 0 01-1.925-16.563 11.85 11.85 0 0113.127-3.804l.716.247-.054-.755a9.765 9.765 0 018.622-10.399 9.869 9.869 0 012.335.009z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M93.5 51.5l3 20m0-22l13 13M133.834 5.315H72.647M27.883 5.315H4.804M28.717 44.289H.411M138.564 44.289H72.44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.12 44.709l4.52-7.987-10.92-6.219 6.4-11.606"
}), /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 49,
  x: 28.638,
  y: 0.5,
  rx: 3,
  transform: "matrix(-1 0 0 1 101.276 0)"
}));

function SvgRoomGasLeak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 118,
    viewBox: "0 0 148 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomGasLeak);
export default __webpack_public_path__ + "static/media/RoomGasLeak.c1aeefc8.svg";
export { ForwardRef as ReactComponent };